import { ChangeDetectionStrategy, Component, computed, inject, Input, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { AbstractControl, ControlValueAccessor, FormControl, NG_VALIDATORS, NG_VALUE_ACCESSOR, ReactiveFormsModule, ValidationErrors, Validator } from '@angular/forms';
import { DragDirective } from 'src/app/directves/drag.directive';
import { toSignal } from '@angular/core/rxjs-interop';
import { Question } from 'src/app/models/question.model';
import { QuestionnaireStore } from 'src/app/store/questionnaire-store';
import { SvgIconComponent } from 'angular-svg-icon';
import { QuestionnaireApiService } from 'src/app/services/questionnaire-api.service';
import { EImageStatus } from 'src/app/models/EnumImageStatus';

@Component({
    selector: 'que-image',
    imports: [CommonModule, TranslateDirective, TranslatePipe, ReactiveFormsModule, DragDirective, SvgIconComponent],
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: ImageComponent,
            multi: true
        },
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: ImageComponent,
            multi: true
        }
    ],
    templateUrl: './image.component.html',
    styleUrls: ['./image.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ImageComponent implements ControlValueAccessor, Validator {
  base64 = new FormControl<string | null>(null);
  base64$ = toSignal(this.base64.valueChanges);
  registerOnChangeCallback: any = () => { };
  onValidationChangeCallBack: any;
  #store = inject(QuestionnaireStore);
  @Input() 
  isDisplay = false;
  question$ = signal<Question | undefined>(undefined);
  // imagesss$ = toSignal(this.#store.imagesToQuestionnaire$)//1524

  // previousImage$ = computed(() => {
  //   var x = this.imagesss$()?.find(x => x.questionId == this.question$()?.id) ?? null

  //   return x;
  // });
  loadDeleteImg$ = toSignal(this.#store.loadDeleteImg$);
  enumImageStatus=EImageStatus;

  #service = inject(QuestionnaireApiService);

  constructor() {
    this.base64.valueChanges.subscribe(base64 => {
      if (this.registerOnChangeCallback)
        this.registerOnChangeCallback({ ...this.question$(), imageBase64: base64 })
    })
  }

  writeValue(obj: Question): void {
    this.question$.set(obj);
    if (obj.imageBase64) {
      this.base64.setValue(obj.imageBase64)
    }
  }
  registerOnChange(fn: any): void {
    this.registerOnChangeCallback = fn;
  }
  registerOnTouched(fn: any): void {
  }
  removePrevious() {
    if (this.question$()?.id && this.question$()?.id != 0)
      this.#store.deleteImageFromServer(this.question$()?.id!)
  }
  validate(control: AbstractControl<any, any>): ValidationErrors | null {
    if (this.base64.valid) {
      return null;
    }
    return { 'answerForm': "not-valid" }
  }
  registerOnValidatorChange?(fn: () => void): void {
    this.onValidationChangeCallBack = fn;
  }

  onFileSelected(event: any) {
    if (event.target.files) {
      const file = event.target.files[0]
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        var base64 = reader.result;
        this.question$.set({...this.question$()??{} as Question ,statusImage:EImageStatus.Changed})
        this.base64.setValue(base64 as string);
      };
    }
  }
  convertFileToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = (event: any) => {
        resolve(event.target.result);
      };

      reader.onerror = (error) => {
        reject(error);
      };

      reader.readAsDataURL(file);
    });
  }
  async filesDroped(evt: any) {
    const reader = new FileReader();
    reader.readAsDataURL(evt);
    reader.onload = () => {
      var base64 = reader.result;
      this.base64.setValue(base64 as string);
    };
  }
  remove() {
    this.question$.set({...this.question$()??{} as Question ,statusImage:EImageStatus.Changed})
    this.base64.setValue(null);
  }
}
